import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Articles from "../pages/articles/page";
import ArticleDetail from "../pages/articles/detail";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles",
    element: <Articles />,
  },
  {
    path: "/articles/:id",
    element: <ArticleDetail />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;